import { Handshake, Globe, Clock, Sparkles, Heart } from "lucide-react";

export default function About() {
  const companyValues = [
    {
      title: "Purpose",
      text: "We exist to help and support individuals accomplish their assignments.",
    },
    {
      title: "Mission",
      text: "To provide simplified and integrated delivery solutions that free individuals and organizations to focus on their assignments.",
    },
    {
      title: "Vision",
      text: "To be an organization known for excellence and social impact for this and the next generation.",
    },
    {
      title: "Brand Promise",
      text: "We promise reliable, end-to-end delivery that is simple, seamless, and non-disruptive.",
    },
  ];

  return (
    <div className="bg-gray-50 text-gray-900">
      {/* HERO */}
      <section className="bg-white py-24 px-6 text-center border-b">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center px-4 py-1 rounded-full bg-gray-100 text-sm text-black-700 mb-6">
            Delivery • Logistics • Reliability
          </div>

          <h1 className="text-5xl font-extrabold tracking-tight text-gray-900">
            About <span className="text-orange-500">Jopo</span>
          </h1>

          <p className="mt-4 text-xl font-medium text-gray-700">"Carry On"</p>

          <p className="mt-6 text-gray-600 leading-relaxed">
            Reliable, seamless delivery that frees you to focus on what matters
            most.
          </p>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="max-w-5xl mx-auto px-6 py-20">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
          Who We Are
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          {companyValues.map((item) => (
            <div
              key={item.title}
              className="bg-white border rounded-2xl p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition"
            >
              <h3 className="text-xl font-semibold text-orange-500 mb-3">
                {item.title}
              </h3>

              <p className="text-gray-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CORE VALUES */}
      <section className="bg-white py-20 border-t border-b">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
          Core Values
        </h2>

        <div className="max-w-5xl mx-auto px-6 grid gap-8 md:grid-cols-2">
          <ValueCard title="Service" Icon={Handshake} color="orange">
            We support individuals and organizations with care.
          </ValueCard>

          <ValueCard title="Impact" Icon={Globe} color="green">
            We aim to create meaningful and lasting change in communities.
          </ValueCard>

          <ValueCard title="Reliability" Icon={Clock} color="orange">
            We honor our word through consistent and dependable delivery.
          </ValueCard>

          <ValueCard title="Faith" Icon={Sparkles} color="green">
            We are guided by purpose and belief in meaningful work.
          </ValueCard>

          <ValueCard title="Humbleness" Icon={Heart} color="orange">
            We act with humility and always support others.
          </ValueCard>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-green-900 text-white max-w-5xl mx-auto my-20 rounded-2xl p-10 text-center flex flex-col items-center justify-center">
        <h3 className="text-2xl font-bold mb-3">
          Ready to experience seamless delivery?
        </h3>

        <p className="text-gray-300 mb-6 max-w-xl">
          Let <span className="text-orange-500 font-semibold">Jopo</span> handle
          the logistics while you focus on what matters most.
        </p>

        <button className="bg-orange-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-orange-600 hover:scale-105 transition">
          Get Started
        </button>
      </section>

      <section className="text-center pb-16 pt-10 border-t">
        <p className="text-2xl font-bold text-gray-900">
          <span className="text-orange-500">Jopo</span>: We carry it. You Carry
          On.
        </p>

        <p className="text-gray-500 mt-3 max-w-xl mx-auto">
          Reliable, seamless delivery that frees you to focus on what matters
          most.
        </p>
      </section>
    </div>
  );
}

/* VALUE CARD */
function ValueCard({ title, children, Icon, color }) {
  const iconColor =
    color === "green"
      ? "bg-green-100 text-green-600"
      : "bg-orange-100 text-orange-600";

  return (
    <div className="bg-white border rounded-2xl p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition">
      <div
        className={`w-14 h-14 flex items-center justify-center rounded-2xl mb-5 ${iconColor}`}
      >
        <Icon size={26} />
      </div>

      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>

      <p className="text-gray-700 leading-relaxed">{children}</p>
    </div>
  );
}
